import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PlanningInsights from "PlanningInsights";
export default store => ({
  path: ":yearGroupId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([import("./components")]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [PlanningInsights(store)],
});
